export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

// Add other configuration values as needed
export const DEFAULT_AVATAR = '/default-avatar.png';
export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB in bytes
export const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/gif']; 